(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hero"] && !Shopify.designMode) return;
  try {
    (() => {
    const LIST_SELECTOR = '[data-restaurant-banner-list]';
    const ITEM_SELECTOR = 'li[data-restaurant-banner]';
    const IMAGE_SELECTOR = '.image__hero__scale > img';

    const updateBannerImage = (list, target) => {
      const item = target.closest(ITEM_SELECTOR);

      if (!item || !list.contains(item)) {
        return;
      }

      const bannerUrl = item.dataset.restaurantBanner;

      if (!bannerUrl) {
        return;
      }

      const hero = list.closest('.index-hero');
      const image = hero?.querySelector(IMAGE_SELECTOR);

      if (!image) {
        return;
      }

      image.src = bannerUrl;
      image.srcset = bannerUrl;
    };

    const preloadImages = (list) => {
      const items = list.querySelectorAll(ITEM_SELECTOR);
      items.forEach((item) => {
        const url = item.dataset.restaurantBanner;
        if (url) {
          const img = new Image();
          img.src = url;
        }
      });
    };

    const init = () => {
      document.querySelectorAll(LIST_SELECTOR).forEach((list) => {
        if (list.dataset.restaurantBannerInitialized === 'true') {
          return;
        }

        list.dataset.restaurantBannerInitialized = 'true';

        preloadImages(list);

        list.addEventListener('mouseover', (event) => {
          updateBannerImage(list, event.target);
        });

        list.addEventListener(
          'touchstart',
          (event) => {
            updateBannerImage(list, event.target);
          },
          { passive: true }
        );
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
      return;
    }

    init();
  })();
  } catch(e) { console.error(e); }
})();

})();
